import { GetOktaTokenInput } from './utils/Authentication.gql';

// Config type
export type Config = {
  digitalOkta: GetOktaTokenInput;
  bffUrl: string | undefined;
  enableCoreIntegration: boolean;
  bamboraUrl: string | undefined;
  apiBaseUrl: string | undefined;
  apiManagementKey: string | undefined;
  stripeKey: string | undefined;
};

// Export the basic configuration
export const config: Config = {
  digitalOkta: {
    clientId: '',
    clientSecret: '',
    grantType: '',
    scope: '',
  },

  // BFF
  bffUrl: process.env.REACT_APP_BFF_URL,
  enableCoreIntegration:
    process.env.REACT_APP_ENABLE_ENCORE_INTEGRATION === 'True',
  bamboraUrl: process.env.REACT_APP_BAMBORA_CUSTOM_CHECKOUT_URL,

  // axios request
  apiBaseUrl: process.env.REACT_APP_BASE_URL,
  apiManagementKey: process.env.REACT_APP_API_MANAGEMENT_KEY,
  stripeKey: process.env.REACT_APP_STRIPE_KEY,
};
